<template>
  <div class="container body">
    <div class="main_container">
      <div
        v-if="!isMobileViewport"
        class="col-md-3 left_col no-print netpa-sidebar"
      >
        <div :class="GetMode()">
          <!-- نام شرکت (بالای سایدبار) -->
          <div
            v-if="customerName"
            class="netpa-sidebar-brand"
            dir="rtl"
            :title="customerName"
          >
            <span class="netpa-brand-mark" aria-hidden="true">
              <i class="fas fa-landmark"></i>
            </span>
            <span class="netpa-sidebar-brand__name">{{ customerName }}</span>
          </div>

          <!-- sidebar menu -->
          <div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
            <div class="menu_section">
              <ul class="nav side-menu">
                <li style="width: 100%">
                  <router-link
                    :to="{ name: 'Home' }"
                    :aria-label="Pishkhan.name"
                  >
                    <i class="fas fa-home" aria-hidden="true"></i>
                    <span class="font-small matn">{{ Pishkhan.name }}</span>
                  </router-link>
                </li>
                <!-- راهـــــــــبری پورتال -->
                <li style="width: 100%" v-if="$session.get('IsRahbar')">
                  <a href="javascript:void(0)" aria-label="راهبر سیستم">
                    <i class="far fa-user" aria-hidden="true"></i>
                    <span class="font-small matn">راهبر سیستم</span>
                    <span
                      class="remove-sm fas fa-chevron-down"
                      aria-hidden="true"
                    ></span>
                  </a>
                  <ul class="nav child_menu">
                    <li class="netpa-flyout-heading">راهبر سیستم</li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'Accessability' }">
                        دسترسی منوها
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'Gateway' }">
                        تنظیمات
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'UsersSetting' }"
                        >بررسی وضعیت کاربران
                      </router-link>
                    </li>
                    <li class="sub_menu" v-if="isWebSiteView">
                      <router-link :to="{ name: 'WebSiteSetting' }"
                        >تنظیمات سایت</router-link
                      >
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'MangeDownloadForms' }"
                        >مدیریت فایلها
                      </router-link>
                    </li>
                    <li
                      v-if="
                        $session.get('IsRahbar') &&
                        $session.get('CustCode') == '801'
                      "
                    >
                      <a href="javascript:;" @click="GotoToTabloo()">
                        ثبت تابلو اعلانات
                      </a>
                    </li>
                    <li v-if="$session.get('IsRahbar')">
                      <router-link :to="{ name: 'SettingVam' }">
                        تنظیمات درخواست وام
                      </router-link>
                    </li>
                    <li v-if="$session.get('IsRahbar')">
                      <router-link :to="{ name: 'FAQManagement' }">
                        پرسش و پاسخ‌های متداول
                      </router-link>
                    </li>
                  </ul>
                </li>
                <!-- درخواســـت ها برای مشتـــری 932 تامین اجتمــاعی -->
                <li
                  style="width: 100%"
                  v-if="
                    $session.get('IsRahbar') &&
                    ($session.get('CustCode') == '932' ||
                      $session.get('CustCode') == '8002')
                  "
                >
                  <a href="javascript:void(0)" aria-label="لیست درخواست ها">
                    <i class="far fa-compass" aria-hidden="true"></i>
                    <span class="font-small matn">لیست درخواست ها </span>
                    <span
                      class="remove-sm fas fa-chevron-down"
                      aria-hidden="true"
                    ></span>
                  </a>
                  <ul class="nav child_menu">
                    <li class="netpa-flyout-heading">لیست درخواست ها</li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ListVamRequests' }">
                        درخواست های وام
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ListRegisterRequests' }">
                        درخواست های عضویت
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ListRequestLetterEnseraf' }">
                        درخواست های انصراف
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link
                        :to="{ name: 'ListRequestLetterSodorEsterdad' }"
                      >
                        درخواست های استرداد سپرده</router-link
                      >
                    </li>
                    <li class="sub_menu">
                      <router-link
                        :to="{ name: 'ListRequestLetterTaghirAghsat' }"
                      >
                        درخواست های تغییر اقساط
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link
                        :to="{ name: 'ListRequestLetterTaghirModatSepordeh' }"
                      >
                        درخواست های تغییر مدت سپرده
                      </router-link>
                    </li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ListAzaFile' }">
                        دریافت فایل
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li style="width: 100%" v-if="$session.get('ModirShobe')">
                  <a href="javascript:void(0)" aria-label="مدیر شعبه">
                    <i class="far fa-user" aria-hidden="true"></i>
                    <span class="font-small matn">مدیر شعبه</span>
                    <span
                      class="remove-sm fas fa-chevron-down"
                      aria-hidden="true"
                    ></span>
                  </a>
                  <ul class="nav child_menu">
                    <li class="netpa-flyout-heading">مدیر شعبه</li>
                    <li class="sub_menu">
                      <router-link :to="{ name: 'ManagUsers' }">
                        مدیریت کاربران
                      </router-link>
                    </li>
                    <li
                      v-if="$session.get('UserInfoNetPaModirShobe') != null"
                      class="sub_menu"
                    >
                      <a href="javascript:;" @click="GotoModirShobe()">
                        بازگشت به پنل مدیر
                      </a>
                    </li>
                    <li
                      v-if="
                        $session.get('ModirShobe') &&
                        $session.get('CustCode') == '801'
                      "
                    >
                      <a href="javascript:;" @click="GotoToTabloo()">
                        ثبت تابلو اعلانات
                      </a>
                    </li>
                    <li
                      v-if="
                        $session.get('ModirShobe') &&
                        $session.get('CustCode') == '801'
                      "
                    >
                      <a href="javascript:;" @click="GoToSettingVam()">
                        تنظیمات درخواست وام
                      </a>
                    </li>
                  </ul>
                </li>

                <li
                  v-for="(item, index) in mainMenuLi"
                  :key="index"
                  style="width: 100%"
                >
                  <a href="javascript:void(0)" :aria-label="item.name">
                    <i :class="menuIconFor(item)" aria-hidden="true"></i>
                    <span class="font-small matn">{{ item.name }}</span>
                    <span
                      class="remove-sm fas fa-chevron-down"
                      aria-hidden="true"
                    ></span>
                  </a>
                  <ul class="nav child_menu">
                    <li class="netpa-flyout-heading">{{ item.name }}</li>
                    <li
                      class="sub_menu"
                      v-for="(menu, index) in Getchild(item.id)"
                      :key="index"
                    >
                      <router-link
                        :to="{
                          name: menu.routeName,
                          params: menu.params != null ? menu.params : '',
                        }"
                        :event="isParamSwitchMenu(menu) ? '' : 'click'"
                        @click.native="onMenuLinkClick(menu)"
                        :active-class="menuLinkActiveClass(menu, 'router-link-active')"
                        :exact-active-class="
                          menuLinkActiveClass(menu, 'router-link-exact-active')
                        "
                        >{{ menu.name }}</router-link
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <!-- /sidebar menu -->

          <!-- تایمر خروج (پایین سایدبار) -->
          <div
            class="netpa-timer-pill"
            dir="rtl"
            title="پس از اين زمان شما بصورت خودکار از سامانه خارج خواهيد شد"
          >
            <span class="netpa-timer-pill__icon" aria-hidden="true">
              <i class="far fa-clock"></i>
            </span>
            <div class="netpa-timer-pill__body">
              <span class="netpa-timer-pill__label"
                >زمان باقیمانده تا خروج</span
              >
              <input
                value="10:00"
                name="b_Timer"
                id="b_Timer"
                readonly="true"
                tabindex="-1"
                dir="ltr"
                class="netpa-timer-pill__value"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- top navigation -->
      <div class="top_nav no-print">
        <div class="nav_menu">
          <nav class="nav navbar-nav text-left pl-5">
            <div class="row netpa-header-row">
              <div class="col-12">
                <a
                  v-if="!isMobileViewport"
                  id="menu_toggle"
                  href="javascript:;"
                  class="netpa-header-toggle"
                  title="جمع/باز کردن منو"
                  aria-label="جمع و باز کردن منو"
                >
                  <span class="netpa-toggle-icon" aria-hidden="true">
                    <span></span>
                    <span></span>
                    <span></span>
                    <svg
                      class="netpa-toggle-arrow"
                      viewBox="0 0 18 14"
                      width="18"
                      height="14"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M1 7H17M11 1.5L16.5 7L11 12.5" />
                    </svg>
                  </span>
                </a>
                <ul
                  class="nav navbar-right netpa-header-actions"
                  :class="{ 'netpa-header-has-cart': GetCart > 0 }"
                  dir="ltr"
                >
                  <li class="open netpa-header-user">
                    <a
                      href="javascript:;"
                      class="user-profile dropdown-toggle netpa-user-menu"
                      aria-haspopup="true"
                      id="navbarDropdown"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        :src="avatarSrc"
                        alt=""
                        class="netpa-header-avatar"
                      />
                      <span class="netpa-user-menu__copy">
                        <strong class="netpa-user-menu__name">{{
                          userDisplayName
                        }}</strong>
                        <small v-if="lastLogin" class="netpa-user-menu__meta"
                          >آخرین ورود: {{ lastLogin }}</small
                        >
                      </span>
                    </a>
                    <div
                      dir="rtl"
                      class="dropdown-menu dropdown-usermenu pull-right text-right netpa-user-dropdown"
                    >
                      <div class="netpa-user-dropdown__ip">
                        <span class="netpa-user-dropdown__label">آدرس IP</span>
                        <span class="netpa-user-dropdown__value" dir="ltr">{{
                          UserIp || "—"
                        }}</span>
                      </div>
                      <a
                        class="dropdown-item netpa-user-dropdown__logout"
                        @click.prevent="LogOut()"
                        href="javascript:;"
                      >
                        <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
                        <span>خروج</span>
                      </a>
                    </div>
                  </li>
                  <li
                    v-if="GetCart > 0"
                    class="open netpa-header-cart-item"
                    style="padding-left: 15px"
                  >
                    <a
                      href="javascript:;"
                      class="user-profile netpa-header-cart-link"
                      @click="GoToCart()"
                    >
                      <span class="netpa-header-cart-chip">
                        <i
                          class="fas fa-shopping-bag netpa-header-cart-icon bounce"
                          aria-hidden="true"
                        ></i>
                        <b class="netpa-header-cart-count">{{ GetCart }}</b>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
      <!-- top navigation -->

      <!-- page content -->
      <div class="right_col" role="main">
        <div class="">
          <div class="m-3 p-5" v-if="this.$route.name == 'Pishkhan'">
            <!-- <shortcut></shortcut> -->
          </div>
          <router-view :key="routeViewKey"></router-view>
        </div>
      </div>
      <!-- page content -->
      <footer>
        <div class="clearfix"></div>
      </footer>
      <mobile-bottom-nav
        v-if="bottomNavItems.length"
        variant="netpa"
        :items="bottomNavItems"
      />
    </div>
  </div>
</template>
<script>
import MobileBottomNav from "../MobileBottomNav.vue";
import {
  buildNetPaBottomNavItems,
  getCartBadgeCount,
  isMobileScreenWidth,
} from "../../../utils/mobileBottomNav";

export default {
  components: {
    MobileBottomNav,
  },
  data() {
    return {
      Route: "",
      AllMenu: {},
      mainMenuLi: [],
      Pishkhan: {},
      UserIp: "",
      isWebSiteView: false,
      isMobileViewport: false,
      defaultAvatar: "/Template/NewMenu/img/userNew.jpg",
    };
  },
  methods: {
    /** آیکن مناسب برای نام منو + outline در صورت امکان */
    menuIconFor(item) {
      var name = (item && item.name) || "";
      if (name === "سایر" || name === "ساير") {
        return "fas fa-ellipsis-h";
      }
      return this.outlineMenuIcon(item && item.menuIcone);
    },
    /** آیکن‌های outline (far) فقط اگر در FA Free Regular موجود باشند */
    outlineMenuIcon(iconClass) {
      if (!iconClass || typeof iconClass !== "string") {
        return "far fa-circle";
      }
      var farIcons = {
        "fa-address-book": 1,
        "fa-address-card": 1,
        "fa-bell": 1,
        "fa-bookmark": 1,
        "fa-building": 1,
        "fa-calendar": 1,
        "fa-calendar-alt": 1,
        "fa-calendar-check": 1,
        "fa-chart-bar": 1,
        "fa-check-circle": 1,
        "fa-check-square": 1,
        "fa-circle": 1,
        "fa-clipboard": 1,
        "fa-clock": 1,
        "fa-clone": 1,
        "fa-comment": 1,
        "fa-comments": 1,
        "fa-compass": 1,
        "fa-copy": 1,
        "fa-credit-card": 1,
        "fa-edit": 1,
        "fa-envelope": 1,
        "fa-envelope-open": 1,
        "fa-eye": 1,
        "fa-file": 1,
        "fa-file-alt": 1,
        "fa-folder": 1,
        "fa-folder-open": 1,
        "fa-heart": 1,
        "fa-id-badge": 1,
        "fa-id-card": 1,
        "fa-image": 1,
        "fa-images": 1,
        "fa-list-alt": 1,
        "fa-map": 1,
        "fa-newspaper": 1,
        "fa-paper-plane": 1,
        "fa-save": 1,
        "fa-star": 1,
        "fa-sticky-note": 1,
        "fa-trash-alt": 1,
        "fa-user": 1,
        "fa-user-circle": 1,
      };
      var parts = iconClass.trim().split(/\s+/);
      var name = parts.find(function (p) {
        return p.indexOf("fa-") === 0 && p !== "fa";
      });
      if (name && farIcons[name]) {
        return "far " + name;
      }
      return iconClass;
    },
    syncMobileLayout() {
      this.isMobileViewport = isMobileScreenWidth();
      if (this.isMobileViewport) {
        document.body.classList.add("netpa-mobile-no-sidebar");
        document.body.classList.remove("netpa-has-sidebar");
      } else {
        document.body.classList.remove("netpa-mobile-no-sidebar");
        document.body.classList.add("netpa-has-sidebar");
      }
    },
    GotoModirShobe() {
      this.$session.set(
        "UserInfoNetPa",
        this.$session.get("UserInfoNetPaModirShobe"),
      );
      this.$session.set("UserInfoNetPaModirShobe", null);
      if (this.$router.name != "Home") {
        this.$router.push("/PishkhanNetPa/Home");
        window.location.reload();
      } else {
        window.location.reload();
      }
    },
    close() {
      document.getElementById("menu_toggle").click();
    },
    GoToPishkhan() {
      this.$router.push("/PishkhanNetPa");
    },
    GotoToTabloo() {
      this.$router.push("TablooElanat");
    },
    GoToSettingVam() {
      this.$router.push("SettingVam");
    },
    Getavatar() {
      return this.avatarSrc;
    },
    LogOut() {
      var DataAxios = {
        Method: "Post",
        Action: "Logout",
        ArryfildValue: {},
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(DataAxios).then((result) => {
        //console.log(result);
        this.$store.state.Netpa_Cart = [];
        this.$store.state.AzaPicSrc = "";
        this.$store.state.AzaPicId = null;
        this.$router.push("/");
        this.$session.clear();
        sessionStorage.removeItem("vuex");
        this.$store.state.PanelRout = [];
        this.$ResetTimer();
      });
    },
    GetMode() {
      var a = false;
      if (a == true) {
        return "left_col_Light scroll-view";
      } else {
        return "left_col scroll-view";
      }
    },
    GetMenus() {
      var result = this.$session.get("AllMenu");
      this.Pishkhan = result[0];
      result.forEach((element) => {
        if (element.params != null) {
          var withQuotes = element.params.replace(
            /(\b[a-z]+:)?(\b[a-z]+\b)/gi,
            '"$2"',
          );
          var parsed = JSON.parse(withQuotes);
          for (const [key, value] of Object.entries(parsed)) {
            if (value === "true") {
              parsed[key] = true;
            }
            if (value === "false") {
              parsed[key] = false;
            }
          }

          element.params = parsed;
        }
        this.AllMenu = result;
        if (element.isParentMenu == true) {
          this.mainMenuLi.push(element);
        }
      });
    },
    // آیتم‌هایی که route یکسان دارند و فقط با param (IsTashilat) فرق می‌کنند
    isParamSwitchMenu(menu) {
      return menu.params != null && menu.params.IsTashilat !== undefined;
    },
    // vue-router وقتی path یکسان باشد ناوبری را «تکراری» حساب کرده و کاری
    // نمی‌کند؛ پس برای این آیتم‌ها خودمان با یک query یکتا ناوبری می‌کنیم.
    onMenuLinkClick(menu) {
      if (!this.isParamSwitchMenu(menu)) {
        return;
      }
      if (
        this.$route.name === menu.routeName &&
        String(this.$route.params.IsTashilat) === String(menu.params.IsTashilat)
      ) {
        return;
      }
      this.$router
        .push({
          name: menu.routeName,
          params: menu.params,
          query: { t: Date.now() },
        })
        .catch(() => {});
    },
    // چند آیتم منو (مثل «واریز به حساب» و «پرداخت اقساط») یک route دارند و فقط
    // در params فرق می‌کنند؛ vue-router هر دو را active می‌کند. اینجا فقط
    // آیتمی که با params فعلی route می‌خواند کلاس active می‌گیرد.
    menuLinkActiveClass(menu, defaultClass) {
      if (
        menu.params != null &&
        menu.params.IsTashilat !== undefined &&
        this.$route.name === menu.routeName &&
        this.$route.params.IsTashilat !== undefined &&
        String(this.$route.params.IsTashilat) !== String(menu.params.IsTashilat)
      ) {
        return "netpa-menu-link-inactive";
      }
      return defaultClass;
    },
    Getchild(id) {
      var childs = [];
      for (var i = 0; i < this.AllMenu.length; i++) {
        var element = this.AllMenu[i];
        if (element.parentId == id) {
          childs.push(element);
        }
      }
      return childs;
    },
    GoToCart() {
      if (this.$route.name != "Cart") {
        this.$router.push({
          name: "Cart",
        });
      }
    },
    reinitSidebar() {
      if (typeof window.reinitNetPaSidebar === "function") {
        window.reinitNetPaSidebar();
      }
      this.$nextTick(() => this.markActiveMenu());
    },
    markActiveMenu() {
      var menu = document.getElementById("sidebar-menu");
      if (!menu) {
        return;
      }
      var isCollapsed = document.body.classList.contains("nav-sm");
      var topItems = menu.querySelectorAll(".menu_section > ul.side-menu > li");

      menu.querySelectorAll("li.current-page").forEach(function (li) {
        li.classList.remove("current-page");
      });

      // فقط لینک دقیق صفحه فعلی (نه همه router-link-activeهای والد)
      var link =
        menu.querySelector("ul.child_menu a.router-link-exact-active") ||
        menu.querySelector("ul.child_menu a.router-link-active") ||
        menu.querySelector(
          ".menu_section > ul.side-menu > li > a.router-link-exact-active",
        ) ||
        menu.querySelector(
          ".menu_section > ul.side-menu > li > a.router-link-active",
        );

      if (!link) {
        return;
      }

      var itemLi = link.closest("li");
      if (itemLi) {
        itemLi.classList.add("current-page");
      }

      var childMenu = link.closest("ul.child_menu");
      var parentLi = childMenu ? childMenu.parentElement : itemLi;

      if (!parentLi) {
        return;
      }
      parentLi.classList.add("current-page");

      if (isCollapsed) {
        return;
      }

      // فقط همین بخش باز بماند؛ بقیه بسته شوند
      topItems.forEach(function (li) {
        var ul = null;
        for (var c = 0; c < li.children.length; c++) {
          if (
            li.children[c].classList &&
            li.children[c].classList.contains("child_menu")
          ) {
            ul = li.children[c];
            break;
          }
        }
        if (li === parentLi) {
          li.classList.add("active");
          li.classList.remove("active-sm");
          if (ul) {
            ul.style.display = "block";
          }
        } else {
          li.classList.remove("active", "active-sm");
          if (ul) {
            ul.style.display = "none";
          }
        }
      });
    },
  },
  watch: {
    isMobileViewport(val, oldVal) {
      if (!val && oldVal) {
        this.$nextTick(() => this.reinitSidebar());
      }
    },
    $route() {
      this.$nextTick(() => this.markActiveMenu());
    },
  },
  async created() {
    this.syncMobileLayout();
    this.$FetchAzaPic();
    try {
      this.GetMenus();
    } catch (e) {}
    this.isWebSiteView = await this.$IsWebSiteView();
    this.$nextTick(() => this.reinitSidebar());
  },
  mounted() {
    this.syncMobileLayout();
    this.$FetchAzaPic();
    window.addEventListener("resize", this.syncMobileLayout);
    window.netpaMarkActiveMenu = () => this.markActiveMenu();
    this.$GetipClient()
      .then((data) => {
        this.UserIp = data.data.ip;
      })
      .catch(() => {
        this.UserIp = "127.0.0.1";
      });
    this.$nextTick(() => this.reinitSidebar());
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.syncMobileLayout);
    if (window.netpaMarkActiveMenu) {
      delete window.netpaMarkActiveMenu;
    }
    document.body.classList.remove("netpa-mobile-no-sidebar");
    document.body.classList.remove("netpa-has-sidebar");
  },
  computed: {
    // با تغییر param ها (مثلا IsTashilat) کامپوننت صفحه از نو ساخته می‌شود
    routeViewKey() {
      return this.$route.fullPath + "|" + String(this.$route.params.IsTashilat);
    },
    avatarSrc() {
      return this.$store.state.AzaPicSrc || this.defaultAvatar;
    },
    userDisplayName() {
      var u = this.$session.get("UserInfoNetPa") || {};
      return ((u.ozvName || "") + " " + (u.ozvFamily || "")).trim();
    },
    customerName() {
      var u = this.$session.get("UserInfoNetPa") || {};
      return u.customerName || "";
    },
    lastLogin() {
      var u = this.$session.get("UserInfoNetPa") || {};
      return u.axarinVorodBeSite || "";
    },
    GetCart() {
      return getCartBadgeCount(this.$store);
    },
    bottomNavItems() {
      return buildNetPaBottomNavItems(this.$session, {
        isWebSiteView: this.isWebSiteView,
        allMenuRaw: this.$session.get("AllMenu"),
      });
    },
  },
};
</script>
<style scoped>
@media print {
  .no-print {
    display: none !important;
  }
}

.nav-sm .nav.side-menu li a span.font-small {
  font-size: 0.6rem !important;
  margin-right: 0 !important;
}

#app {
  font-size: 14px;
}

#app *:not(i):not(.fa):not(.fas):not(.far):not(.fab) {
  font-size: 12px !important;
  clear: both !important;
}

#app i,
#app .fa,
#app .fas,
#app .far,
#app .fab {
  clear: none !important;
}

.wrapper {
  font-size: 12px !important;
}

.main-sidebar {
  z-index: 1000 !important;
  height: 100vh;
  overflow-y: hidden;
}

i.fa-circle-o {
  color: #287db4 !important;
}

.menu-open > a {
  background: rgba(40, 125, 180, 0.08) !important;
}

.dropdown-menu-lg {
  min-width: 170px;
  max-width: 300px;
  padding: 0;
  text-align: center;
}

.Nohover:hover {
  background: #ededed;
}

.pull-right {
  text-align: right;
}
</style>
<style>
/* توکن‌های NetPa — همراستا با docs/NETPA_DESIGN_SYSTEM.md */
.netpa-sidebar {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-brand-blue: #287db4;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-icon-muted: #8091a3;
  --bnp-surface-page: #f5f7fb;
  --bnp-surface-accent: #edf7fb;
  --bnp-border-default: #e1e8ee;
  --bnp-border-subtle: #e8eef2;
  --bnp-radius-md: 14px;
  --bnp-radius-lg: 20px;
  --bnp-radius-pill: 999px;
  --bnp-shadow-sm: 0 5px 18px rgba(31, 42, 79, 0.08);
  --bnp-motion-fast: 180ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);
}

/* پس‌زمینه صفحه محتوا — مثل نمونه (#f5f7fb)
   تم قدیمی: body .container.body .right_col { background: #F7F7F7 }
   باید خودِ right_col رنگ بگیرد (transparent دیده نمی‌شود) */
body.netpa-has-sidebar,
body.netpa-has-sidebar #app,
body.netpa-has-sidebar .container.body,
body.netpa-has-sidebar .main_container {
  background-color: #f5f7fb !important;
  background-image: radial-gradient(
      circle at 2% 2%,
      rgba(5, 184, 200, 0.06),
      transparent 24%
    ),
    radial-gradient(
      circle at 98% 98%,
      rgba(141, 88, 164, 0.06),
      transparent 24%
    ) !important;
  background-repeat: no-repeat !important;
}

body.netpa-has-sidebar .right_col,
body.netpa-has-sidebar .container.body .right_col,
body.netpa-has-sidebar.nav-md .container.body .right_col,
body.netpa-has-sidebar.nav-sm .container.body .right_col,
body.netpa-has-sidebar #app .right_col,
body.netpa-has-sidebar #app .container.body .right_col,
body.netpa-has-sidebar #app .main_container .right_col {
  background: #f5f7fb !important;
  background-color: #f5f7fb !important;
  background-image: none !important;
}

body.netpa-has-sidebar .top_nav .nav_menu {
  background: rgba(255, 255, 255, 0.96) !important;
  border-bottom: 1px solid rgba(225, 232, 238, 0.9);
}

/* سطح روشن سایدبار — سفید + فقط یک خط نازک جداکننده */
body.netpa-has-sidebar .netpa-sidebar {
  background: rgba(255, 255, 255, 0.96) !important;
  border: 0 !important;
  border-left: 1px solid #e1e8ee !important;
  box-shadow: none !important;
  overflow: visible;
}

body.netpa-has-sidebar .netpa-sidebar > .left_col,
body.netpa-has-sidebar .netpa-sidebar > .left_col_Light {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  padding: 12px 10px 12px !important;
  box-sizing: border-box;
  display: flex !important;
  flex-direction: column;
  min-height: 100%;
}

.netpa-sidebar #sidebar-menu.main_menu_side {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  margin-top: 0 !important;
  padding: 0 4px !important;
}
.netpa-sidebar-brand {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding: 4px 2px;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  clear: none !important;
}

.netpa-sidebar-brand .netpa-brand-mark {
  flex: 0 0 auto;
}

.netpa-sidebar-brand__name {
  flex: 1 1 auto;
  min-width: 0;
  color: var(--bnp-brand-navy, #29345f);
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.45;
  letter-spacing: -0.01em;
  text-align: right;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  clear: none !important;
}

.netpa-timer-pill {
  flex: 0 0 auto;
  margin-top: 10px;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  box-shadow: none;
  clear: none !important;
}

.netpa-timer-pill__icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  color: var(--bnp-brand-navy);
  background: var(--bnp-surface-accent);
  border: 1px solid rgba(40, 125, 180, 0.12);
  clear: none !important;
}

.netpa-timer-pill__icon i {
  font-size: 13px !important;
  clear: none !important;
}

.netpa-timer-pill__body {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  clear: none !important;
}

.netpa-timer-pill__label {
  display: block;
  color: var(--bnp-text-secondary);
  font-size: 10px !important;
  font-weight: 400;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  clear: none !important;
}

.netpa-timer-pill__value,
#b_Timer.netpa-timer-pill__value {
  width: auto !important;
  max-width: 100%;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  color: var(--bnp-brand-indigo) !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  line-height: 1.2;
  text-align: right !important;
  float: none !important;
  clear: none !important;
  cursor: default;
}

/* منو — ساختار و پالت شبیه نمونه (سفید / آبی ملایم) */
.netpa-sidebar #sidebar-menu.main_menu_side {
  margin-top: 0 !important;
  padding: 0 4px !important;
}

.netpa-sidebar .nav.side-menu {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.netpa-sidebar .nav.side-menu > li {
  margin: 0 !important;
  border-bottom: 0;
  clear: none !important;
  position: relative;
  overflow: visible;
}

.netpa-sidebar .nav.side-menu > li:last-child {
  border-bottom: 0;
}

.netpa-sidebar .nav.side-menu > li > a {
  position: relative;
  display: flex !important;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  min-height: 46px;
  padding: 9px 12px !important;
  margin: 0;
  color: #596a7d !important;
  border-radius: 12px;
  direction: rtl;
  clear: none !important;
  transition: background var(--bnp-motion-fast) ease,
    color var(--bnp-motion-fast) ease;
}

.netpa-sidebar .nav.side-menu > li > a:hover {
  color: var(--bnp-brand-blue) !important;
  background: var(--bnp-surface-accent) !important;
}

/* بخش بازشده — سبک‌تر از صفحه فعلی */
.netpa-sidebar .nav.side-menu > li.active > a {
  background: var(--bnp-surface-accent) !important;
  color: var(--bnp-brand-blue) !important;
  box-shadow: none;
}

.netpa-sidebar .nav.side-menu > li.active > a > span.remove-sm {
  transform: rotate(180deg);
  color: var(--bnp-brand-blue) !important;
}

/* صفحه فعلی — گرادیان فیروزه‌ای/بنفش + نوار کناری مثل حالت جمع‌شده */
.netpa-sidebar .nav.side-menu > li.current-page,
.netpa-sidebar .nav.side-menu > li.active {
  border-right: none !important;
  border-left: none !important;
}

.netpa-sidebar .nav.side-menu > li.current-page > a {
  color: var(--bnp-brand-navy) !important;
  font-weight: 700;
  background: linear-gradient(
    100deg,
    rgba(5, 184, 200, 0.1),
    rgba(141, 88, 164, 0.08)
  ) !important;
  box-shadow: none;
}

.netpa-sidebar .nav.side-menu > li.current-page > a::after {
  content: "";
  position: absolute;
  top: 10px;
  bottom: 10px;
  right: 0;
  width: 3px;
  border-radius: 0 999px 999px 0;
  background: linear-gradient(var(--bnp-brand-cyan), var(--bnp-brand-purple));
  pointer-events: none;
}

.netpa-sidebar .nav.side-menu > li.current-page > a > i {
  color: var(--bnp-brand-navy) !important;
}

.netpa-sidebar .nav.side-menu > li.current-page > a > span.font-small,
.netpa-sidebar .nav.side-menu > li.current-page > a > span.matn {
  color: var(--bnp-brand-navy) !important;
  font-weight: 700;
}

#app .netpa-sidebar .nav.side-menu > li > a > i {
  flex: 0 0 auto;
  order: 0;
  width: 22px;
  text-align: center;
  color: #8091a3 !important;
  font-size: 15px !important;
  line-height: 1 !important;
  clear: none !important;
  float: none !important;
}

.netpa-sidebar .nav.side-menu > li > a:hover > i,
.netpa-sidebar .nav.side-menu > li.active > a > i {
  color: var(--bnp-brand-blue) !important;
}

.netpa-sidebar .nav.side-menu > li > a > span.font-small,
.netpa-sidebar .nav.side-menu > li > a > span.matn {
  flex: 1 1 auto;
  order: 1;
  min-width: 0;
  color: inherit !important;
  font-size: 13px !important;
  font-weight: 600;
  text-align: right;
  clear: none !important;
  float: none !important;
  margin-right: 0 !important;
}

.netpa-sidebar .nav.side-menu > li > a > span.remove-sm {
  flex: 0 0 auto;
  order: 2;
  margin-inline-start: auto;
  color: #94a3b8 !important;
  font-size: 11px !important;
  transition: transform var(--bnp-motion-fast) var(--bnp-ease-standard);
  clear: none !important;
  float: none !important;
}

/* زیر‌منو: بولت (بدون خط عمودی) و فاصله کمتر از راست */
.netpa-sidebar .nav.child_menu {
  position: relative;
  margin: 0px 13px 0px 0px !important;
  padding: 2px 8px 6px 8px !important;
  border-right: 1px solid #aaa !important;

  background: transparent !important;
}

.netpa-sidebar .nav.child_menu > li:not(.netpa-flyout-heading) {
  position: relative;
  margin: 2px 0;
  clear: none !important;
}

.netpa-sidebar .nav.child_menu > li:not(.netpa-flyout-heading)::before {
  content: "";
  position: absolute;
  top: 50%;
  right: 10px;
  width: 6px;
  height: 6px;
  margin-top: -3px;
  border-radius: 50%;
  background: transparent;
  border: 1.5px solid rgba(40, 125, 180, 0.45);
  box-shadow: none;
  z-index: 1;
  pointer-events: none;
  clear: none !important;
}

.netpa-sidebar .nav.child_menu > li > a {
  position: relative;
  display: block !important;
  color: #596a7d !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  border-radius: 12px;
  padding: 10px 26px 10px 12px !important;
  text-align: right;
  clear: none !important;
  transition: background var(--bnp-motion-fast) ease,
    color var(--bnp-motion-fast) ease;
}

/* مخفی کردن هر آیکن داخل زیرمنو */
.netpa-sidebar .nav.child_menu > li > a > i,
.netpa-sidebar .nav.child_menu > li > a .fa,
.netpa-sidebar .nav.child_menu > li > a .fas,
.netpa-sidebar .nav.child_menu > li > a .far,
.netpa-sidebar .nav.child_menu > li > a .glyphicon {
  display: none !important;
}

.netpa-sidebar .nav.child_menu > li > a:hover {
  color: var(--bnp-brand-blue) !important;
  background: var(--bnp-surface-accent) !important;
}

/* زیر‌منوی فعلی — مثل نمونه */
.netpa-sidebar .nav.child_menu > li.current-page > a,
.netpa-sidebar .nav.child_menu > li > a.router-link-exact-active {
  color: var(--bnp-brand-navy) !important;
  font-weight: 700 !important;
  background: linear-gradient(
    100deg,
    rgba(5, 184, 200, 0.1),
    rgba(141, 88, 164, 0.08)
  ) !important;
  box-shadow: none;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.child_menu > li.current-page {
  border-right: none !important;
}

.netpa-sidebar .nav.child_menu > li.active > a:not(.router-link-exact-active) {
  color: var(--bnp-brand-blue) !important;
  font-weight: 600 !important;
  background: var(--bnp-surface-accent) !important;
  box-shadow: none;
}

.netpa-sidebar
  .nav.child_menu
  > li.current-page:not(.netpa-flyout-heading)::before {
  background: var(--bnp-brand-blue);
  border-color: var(--bnp-brand-blue);
  box-shadow: 0 0 0 3px rgba(40, 125, 180, 0.16);
}

.netpa-sidebar .nav.child_menu > li.netpa-flyout-heading {
  display: none;
}

/* حذف رنگ نارنجی قدیمی تم */
.netpa-sidebar .text-warning,
body.netpa-has-sidebar .netpa-sidebar .text-warning {
  color: var(--bnp-brand-navy) !important;
}

body.netpa-has-sidebar .netpa-sidebar .menu-open > a {
  background: rgba(40, 125, 180, 0.08) !important;
  color: var(--bnp-brand-navy) !important;
}

/* هدر: کاربر چپ (نام + آخرین ورود) */
.netpa-header-user {
  position: relative;
  padding-left: 0 !important;
  margin-right: 4px;
}

#app .top_nav .netpa-user-menu.user-profile {
  display: inline-flex !important;
  align-items: center;
  gap: 10px;
  max-width: min(46vw, 280px);
  padding: 4px 10px 4px 4px;
  border-radius: 12px;
  border: 1px solid transparent;
  transition: border-color var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease;
}

#app .top_nav .netpa-user-menu.user-profile:hover,
#app .top_nav .netpa-user-menu.user-profile:focus {
  border-color: var(--bnp-border-default, #e1e8ee);
  background: #fff;
}

.netpa-header-avatar {
  width: 40px !important;
  height: 40px !important;
  object-fit: cover !important;
  border-radius: 13px !important;
  clear: none !important;
  display: inline-block !important;
  margin: 0 !important;
  flex: 0 0 40px;
  border: 1px solid var(--bnp-border-subtle, #e8eef2);
}

#app .top_nav .netpa-user-menu__copy {
  display: flex !important;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
  max-width: 100%;
  gap: 2px;
  clear: none !important;
  float: none !important;
  text-align: left;
}

#app .top_nav .netpa-user-menu__name {
  display: block !important;
  max-width: 100%;
  margin: 0;
  color: var(--bnp-brand-navy, #29345f) !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  clear: none !important;
}

#app .top_nav .netpa-user-menu__meta {
  display: block !important;
  max-width: 100%;
  margin: 0;
  color: var(--bnp-text-secondary, #6b7b8e) !important;
  font-size: 10px !important;
  font-weight: 400 !important;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  clear: none !important;
}

.netpa-user-dropdown {
  left: 0 !important;
  right: auto !important;
  min-width: 200px;
  margin-top: 6px;
  padding: 8px 0;
  border: 1px solid var(--bnp-border-default, #e1e8ee);
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(41, 52, 95, 0.12);
}

.netpa-user-dropdown__ip {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 14px 10px;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--bnp-border-subtle, #e8eef2);
  text-align: right;
}

#app .netpa-user-dropdown__label {
  color: var(--bnp-text-secondary, #6b7b8e);
  font-size: 10px !important;
}

#app .netpa-user-dropdown__value {
  color: var(--bnp-brand-navy, #29345f);
  font-size: 12px !important;
  font-weight: 600;
}

#app .top_nav .netpa-user-dropdown__logout.dropdown-item {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 9px 14px !important;
  color: #b44f46 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  direction: rtl;
  text-align: right;
}

#app .top_nav .netpa-user-dropdown__logout.dropdown-item:hover {
  background: #fcefed !important;
  color: #9a3d36 !important;
}

#app .top_nav .netpa-user-dropdown__logout i {
  float: none !important;
  margin: 0 !important;
  color: inherit !important;
  font-size: 14px !important;
  clear: none !important;
}

#app .top_nav .nav_menu {
  position: relative;
  padding-left: var(--netpa-content-inline-inset, 25px) !important;
  padding-right: 8px !important;
  box-sizing: border-box;
}

#app .top_nav .nav_menu .row.netpa-header-row {
  margin-left: 0;
  margin-right: 0;
  position: relative;
  min-height: 56px;
  align-items: center;
}

#app .top_nav .nav_menu .netpa-header-row > .col-12 {
  position: relative;
  padding-left: 0;
  padding-right: 48px; /* جا برای تاگل کنار سایدبار */
  display: flex;
  align-items: center;
  min-height: 56px;
}

/* تاگل منو — چسبیده به لبه سایدبار (راست) */
#app .top_nav .netpa-header-toggle {
  position: absolute !important;
  top: 50%;
  right: 0;
  left: auto;
  transform: translateY(-50%);
  z-index: 6;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin: 0 !important;
  border-radius: 12px;
  color: var(--bnp-brand-navy, #29345f) !important;
  background: #fff;
  border: 1px solid var(--bnp-border-default, #e1e8ee);
  box-shadow: none;
  transition: background 0.25s ease, border-color 0.25s ease,
    box-shadow 0.25s ease;
  clear: none !important;
  float: none !important;
}

#app .top_nav .netpa-header-toggle:hover {
  background: #fff;
  border-color: #bdcbd4;
  box-shadow: 0 2px 8px rgba(41, 52, 95, 0.08);
}

#app .top_nav .netpa-header-toggle:active {
  transform: translateY(-50%) scale(0.96);
}

.netpa-toggle-icon {
  position: relative;
  display: block;
  width: 18px;
  height: 14px;
}

.netpa-toggle-icon > span {
  position: absolute;
  left: 0;
  display: block;
  height: 2px;
  width: 100%;
  border-radius: 999px;
  background: currentColor;
  transition: top 0.34s cubic-bezier(0.4, 0, 0.2, 1),
    left 0.34s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.34s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.24s ease,
    transform 0.34s cubic-bezier(0.4, 0, 0.2, 1);
}

/* فلش (SVG تک‌مسیره، بدون هم‌پوشانی خطوط → بدون نقطه در نوک) */
.netpa-toggle-arrow {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  pointer-events: none;
  transition: opacity 0.24s ease, transform 0.34s cubic-bezier(0.4, 0, 0.2, 1);
}

/* منوی باز: فقط فلش، خطوط همبرگر مخفی */
body.netpa-has-sidebar.nav-md .netpa-toggle-icon > span {
  top: 6px;
  left: 0;
  width: 18px;
  opacity: 0;
  transform: scaleX(0.4);
}

body.netpa-has-sidebar.nav-md .netpa-toggle-arrow {
  opacity: 1;
  transform: none;
}

/* منوی جمع‌شده: فلش مخفی */
body.netpa-has-sidebar.nav-sm .netpa-toggle-arrow {
  opacity: 0;
  transform: translateX(-4px);
}

/* منوی جمع‌شده: سه خط همبرگر */
body.netpa-has-sidebar.nav-sm .netpa-toggle-icon > span:nth-child(1) {
  top: 0;
  left: 0;
  width: 18px;
  transform: none;
}

body.netpa-has-sidebar.nav-sm .netpa-toggle-icon > span:nth-child(2) {
  top: 6px;
  left: 0;
  width: 18px;
  opacity: 1;
  transform: none;
}

body.netpa-has-sidebar.nav-sm .netpa-toggle-icon > span:nth-child(3) {
  top: 12px;
  left: 0;
  width: 18px;
  transform: none;
}

#app .top_nav .nav_menu ul.nav.navbar-right.netpa-header-actions {
  display: flex !important;
  float: none !important;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start !important;
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  margin: 0 !important;
  padding: 0;
  clear: none !important;
}

.netpa-brand-mark {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 11px;
  color: #fff;
  background: linear-gradient(
    135deg,
    var(--bnp-brand-navy, #29345f) 0%,
    var(--bnp-brand-indigo, #56508d) 100%
  );
  box-shadow: 0 4px 12px rgba(41, 52, 95, 0.18);
  clear: none !important;
}

.netpa-brand-mark i {
  font-size: 14px !important;
  clear: none !important;
}

#app .top_nav .nav_menu .navbar-right > li {
  float: none !important;
  display: flex !important;
  align-items: center;
  padding-left: 0 !important;
  clear: none !important;
  direction: rtl;
}

#app .top_nav .user-profile,
#app .top_nav .user-profile img,
#app .top_nav .netpa-user-menu__copy,
#app .top_nav .netpa-user-menu__name,
#app .top_nav .netpa-user-menu__meta {
  clear: none !important;
  float: none !important;
}

#app .top_nav .user-profile:not(.netpa-user-menu) {
  display: inline-flex !important;
  align-items: center;
  flex-wrap: nowrap;
  max-width: 100%;
}

/* سایدبار جمع‌شده: فقط آیکن + فلای‌اوت زیرمنو */
body.netpa-has-sidebar.nav-sm #app .netpa-sidebar .nav.side-menu > li > a,
body.netpa-has-sidebar.nav-sm #app .netpa-sidebar .nav.side-menu > li > a > i,
body.netpa-has-sidebar.nav-sm
  #app
  .netpa-sidebar
  .nav.side-menu
  > li
  > a
  > span {
  clear: none !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .netpa-sidebar-brand {
  justify-content: center;
  padding: 2px 0;
  margin-bottom: 8px;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .netpa-sidebar-brand__name {
  display: none !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .netpa-brand-mark {
  width: 32px;
  height: 32px;
  border-radius: 10px;
}

/* حالت جمع‌شده: فقط زمان (مثلاً 09:05) */
body.netpa-has-sidebar.nav-sm .netpa-sidebar .netpa-timer-pill {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  margin-top: 8px;
  padding: 8px 4px;
  width: 100%;
  box-sizing: border-box;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .netpa-timer-pill__icon,
body.netpa-has-sidebar.nav-sm .netpa-sidebar .netpa-timer-pill__label {
  display: none !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .netpa-timer-pill__body {
  flex: 0 0 auto;
  align-items: center;
  width: 100%;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .netpa-timer-pill__value,
body.netpa-has-sidebar.nav-sm .netpa-sidebar #b_Timer.netpa-timer-pill__value {
  width: 100% !important;
  text-align: center !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  color: var(--bnp-brand-indigo) !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu > li > a {
  position: relative;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 0 !important;
  text-align: center !important;
  min-height: 52px;
  padding: 14px 6px !important;
  border-radius: 14px;
}

#app body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu > li > a > i,
body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu > li > a > i {
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
  font-size: 28px !important;
  line-height: 1 !important;
  color: #8091a3 !important;
}

/* منوی فعال در حالت جمع‌شده */
#app
  body.netpa-has-sidebar.nav-sm
  .netpa-sidebar
  .nav.side-menu
  > li.current-page
  > a,
body.netpa-has-sidebar.nav-sm
  .netpa-sidebar
  .nav.side-menu
  > li.current-page
  > a,
body.netpa-has-sidebar.nav-sm
  .netpa-sidebar
  .nav.side-menu
  > li.active-sm.current-page
  > a {
  background: linear-gradient(
    100deg,
    rgba(5, 184, 200, 0.12),
    rgba(141, 88, 164, 0.1)
  ) !important;
  box-shadow: none;
}

body.netpa-has-sidebar.nav-sm
  .netpa-sidebar
  .nav.side-menu
  > li.current-page
  > a::after {
  right: 0;
  left: auto;
  top: 8px;
  bottom: 8px;
}

#app
  body.netpa-has-sidebar.nav-sm
  .netpa-sidebar
  .nav.side-menu
  > li.current-page
  > a
  > i,
body.netpa-has-sidebar.nav-sm
  .netpa-sidebar
  .nav.side-menu
  > li.current-page
  > a
  > i {
  color: var(--bnp-brand-navy) !important;
  font-size: 28px !important;
}

body.netpa-has-sidebar.nav-sm
  .netpa-sidebar
  .nav.side-menu
  > li
  > a
  > span.font-small,
body.netpa-has-sidebar.nav-sm
  .netpa-sidebar
  .nav.side-menu
  > li
  > a
  > span.matn,
body.netpa-has-sidebar.nav-sm
  .netpa-sidebar
  .nav.side-menu
  > li
  > a
  > span.remove-sm {
  display: none !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu > li {
  position: relative;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar ul.nav.child_menu {
  position: fixed !important;
  left: auto !important;
  right: auto !important;
  width: 220px !important;
  margin: 0 !important;
  padding: 8px !important;
  border: 1px solid var(--bnp-border-subtle) !important;
  border-radius: var(--bnp-radius-lg) !important;
  box-shadow: 0 16px 36px rgba(41, 52, 95, 0.16) !important;
  transition: none !important;
  animation: none !important;
  z-index: 4001 !important;
  background: #fff !important;
  text-align: right !important;
}

body.netpa-has-sidebar.nav-sm
  .netpa-sidebar
  ul.nav.child_menu
  > li:not(.netpa-flyout-heading)::before {
  right: 12px !important;
}

body.netpa-has-sidebar.nav-sm
  .netpa-sidebar
  ul.nav.child_menu
  > li.netpa-flyout-heading {
  display: block !important;
  padding: 10px 12px 8px !important;
  margin-bottom: 4px;
  color: var(--bnp-brand-navy) !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  border-bottom: 1px solid var(--bnp-border-subtle);
  pointer-events: none;
  clear: none !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar ul.nav.child_menu li {
  padding: 0 !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar ul.nav.child_menu li a {
  text-align: right !important;
  border-radius: 10px;
  color: var(--bnp-text-primary) !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu li.active-sm > a {
  background: rgba(41, 52, 95, 0.05) !important;
  box-shadow: none;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu li.active-sm {
  border-right: none !important;
  border-left: none !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu li.current-page {
  border-right: none !important;
  border-left: none !important;
}

body.netpa-has-sidebar.nav-sm .netpa-sidebar .nav.side-menu > li {
  border-bottom: 0;
}

/* تبلت: منو و هدر کاربر خواناتر */
@media (min-width: 768px) and (max-width: 1180px) {
  body.netpa-has-sidebar .netpa-sidebar > .left_col,
  body.netpa-has-sidebar .netpa-sidebar > .left_col_Light {
    padding: 14px 12px 14px !important;
  }

  .netpa-sidebar .nav.side-menu > li > a {
    min-height: 48px;
    padding: 11px 12px !important;
  }

  #app .netpa-sidebar .nav.side-menu > li > a > i {
    font-size: 16px !important;
  }

  .netpa-sidebar .nav.side-menu > li > a > span.font-small,
  .netpa-sidebar .nav.side-menu > li > a > span.matn {
    font-size: 14px !important;
  }

  #app .top_nav .netpa-user-menu.user-profile {
    max-width: min(60vw, 400px);
  }

  #app .top_nav .netpa-user-menu__name {
    font-size: 13px !important;
  }

  #app .top_nav .netpa-user-menu__meta {
    font-size: 11px !important;
  }
}

@media (min-width: 768px) {
  #app .top_nav .nav_menu .netpa-header-row > .col-12 {
    padding-right: 48px;
  }
}

@media (max-width: 767px) {
  body.netpa-mobile-no-sidebar .container.body .right_col,
  body.netpa-mobile-no-sidebar .container.body .top_nav,
  body.netpa-mobile-no-sidebar .main_container .top_nav,
  body.netpa-mobile-no-sidebar .top_nav .nav_menu,
  body.netpa-mobile-no-sidebar footer {
    margin-right: 0 !important;
    margin-left: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    left: 0 !important;
  }

  #app .top_nav .nav_menu .netpa-header-row > .col-12 {
    padding-right: 0;
  }

  #app .top_nav .nav_menu ul.nav.navbar-right.netpa-header-actions {
    max-width: 100%;
  }

  #app .top_nav .netpa-user-menu.user-profile {
    max-width: min(78vw, 340px);
    padding: 4px 8px !important;
  }

  .netpa-header-avatar {
    width: 36px !important;
    height: 36px !important;
    flex-basis: 36px;
  }

  #app .top_nav .netpa-user-menu__name {
    font-size: 12px !important;
  }

  #app .top_nav .netpa-user-menu__meta {
    font-size: 9px !important;
  }

  #app .top_nav .nav_menu ul.nav.navbar-right.netpa-header-has-cart {
    justify-content: space-between !important;
    width: 100%;
  }

  #app .top_nav .netpa-header-cart-item {
    order: -1;
    padding-left: 0 !important;
  }

  #app
    .top_nav
    .nav_menu
    ul.nav.navbar-right.netpa-header-has-cart
    > li.open:not(.netpa-header-cart-item) {
    margin-left: auto;
  }
}

#app .top_nav .netpa-header-cart-link.user-profile {
  display: inline-flex !important;
  align-items: center;
  padding: 0 !important;
}

#app .top_nav .netpa-header-cart-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 56px;
  min-height: 40px;
  padding: 6px 12px;
  color: #c62828;
  border-radius: 14px;
  background: #fdecea;
  box-shadow: inset 0 0 0 1px rgba(229, 57, 53, 0.18);
}

#app .top_nav .netpa-header-cart-icon {
  display: inline-block !important;
  color: #e53935 !important;
  font-size: 16px !important;
  line-height: 1;
}

#app .top_nav .netpa-header-cart-count {
  color: #c62828 !important;
  font-size: 13px !important;
  font-weight: 800;
  line-height: 1;
}

.bounce {
  -webkit-animation-name: bounceIn;
  animation-name: bounceIn;
  -webkit-animation-duration: 0.75s;
  animation-duration: 0.75s;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }

  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }

  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .netpa-sidebar-toggle,
  .netpa-sidebar .nav.side-menu > li > a {
    transition: none !important;
  }

  .bounce {
    animation: none !important;
  }
}
</style>
